import { render, staticRenderFns } from "./AboutOneMenuContent.vue?vue&type=template&id=5290cda2"
import script from "./AboutOneMenuContent.vue?vue&type=script&lang=js"
export * from "./AboutOneMenuContent.vue?vue&type=script&lang=js"
import style0 from "./AboutOneMenuContent.vue?vue&type=style&index=0&id=5290cda2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports